import { Record } from 'immutable'

export const Tag = Record({
  id: null,
  orgId: null,
  color: null,
  name: undefined,
  createdAt: undefined,
  targetType: undefined,
  status: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/models.js